<div class='simple-form-field'>
    <div class='content'>
        <ng-content></ng-content>
    </div>
    <mat-divider class='divider'></mat-divider>
</div>
